import { useQuery } from '@apollo/client';
import { ProductLinesDocument } from '@flashpack/graphql';

export const useProductLines = () => {
  const { data, loading, error } = useQuery(ProductLinesDocument);

  const productLineOptions =
    data?.productLines.map((pl) => ({
      value: pl.slug,
      label: pl.label,
    })) ?? [];

  return { productLineOptions, loading, error };
};
